import React from 'react'
import "./Loading.css"
import logo from  "../../images/logo.png"


function Loading() {
  return (
    <div className='bg-dark container'>
           <div className="row gap-1">
        <div className="col items-center justify-between p-1 ">
            <div className="col-lg-4 col-md-6 col-sm-12 float-start rounded-xl mb-3 shadow shadow-teal-900 overflow-hidden px-1">
          <div className="card bg-gray-50 animate-pulse w-full flex  card-sm-12 card-xs-12 card-md-12">
            <div className="card-header flex flex-row items-center w-full ">
                  <div className="rounded-full overflow-hidden mr-1"><img className='rounded-full bg-black'src={logo} style={{height:45, width:45}} alt="logo" /></div>
            </div>
            <div className="card-body p-0 px-3 pb-2 py-1">
                <div className="border justify-center items-center flex w-full" style={{height:180}}>
                <div className="loading "></div>
                </div>
                {/* post description here */}
                <div className=" flex w-full px-24">
                    <div className="text-lg py-2 h-20 px-1 justify-center items-center flex w-full">
                    <div className="font-bold font-mono w-full">Loading...</div>
                    </div>
                </div>
            </div>
          </div>
          </div>
          {/* --------- */}
            <div className="col-lg-4 col-md-6 col-sm-12 float-start rounded-xl mb-3 shadow shadow-teal-900 overflow-hidden px-1">
          <div className="card w-100 bg-gray-50 animate-pulse">
            <div className="card-header flex flex-row items-center ">
                  <div className="rounded-full overflow-hidden mr-1"><img className='rounded-full bg-black'src={logo} style={{height:45, width:45}} alt="logo" /></div>
            </div>
            <div className="card-body p-0 px-3 pb-2 py-1">
                <div className="border justify-center items-center flex w-full" style={{height:180}}>
                <div className="loading "></div>
                </div>
                {/* post description here */}
                <div className=" flex px-24">
                    <div className="text-lg py-2 h-20 px-1 justify-center items-center flex w-full">
                    <div className="font-bold font-mono">Loading...</div>
                    </div>
                </div>
            </div>
          </div>
          </div>
          {/* --------- */}
            <div className="col-lg-4 col-md-6 col-sm-12 float-start rounded-xl mb-3 shadow shadow-teal-900 overflow-hidden px-1">
          <div className="card w-100 bg-gray-50 animate-pulse">
            <div className="card-header flex flex-row items-center ">
                  <div className="rounded-full overflow-hidden mr-1"><img className='rounded-full bg-black'src={logo} style={{height:45, width:45}} alt="logo" /></div>
            </div>
            <div className="card-body p-0 px-3 pb-2 py-1">
                <div className="border justify-center items-center flex w-full" style={{height:180}}>
                <div className="loading "></div>
                </div>
                {/* post description here */}
                <div className=" flex px-24">
                    <div className="text-lg py-2 h-20 px-1 justify-center items-center flex w-full">
                    <div className="font-bold font-mono">Loading...</div>
                    </div>
                </div>
            </div>
          </div>
          </div>
          {/* --------- */}

        </div>
       </div>
    </div>
  )
}

export default Loading